import React from "react";
import cn from "classnames";
import { useFormControl } from "../FormControl";
import styles from "./FormLabel.module.scss";

interface FormLabelProps {
  children: React.ReactNode;
  required?: boolean;
  className?: string;
  htmlFor?: string;
}

/**
 * FormLabel component
 *
 * Provides a styled label for form fields, automatically
 * connected to the field via the FormControl context.
 */
const FormLabel: React.FC<FormLabelProps> = ({
  children,
  required,
  className,
  htmlFor,
  ...props
}) => {
  const { name } = useFormControl();

  return (
    <label
      htmlFor={htmlFor || name}
      className={cn(styles.formLabel, className)}
      {...props}
    >
      {children}
      {required ? <span className={styles.required}>*</span> : null}
    </label>
  );
};

export default FormLabel;
